enum ScheduleCommand {
  UPDATE_SCHEDULE_MANUALLY = 'UPDATE_SCHEDULE_MANUALLY',
  QUEUE_SCHEDULE_ASSIGNMENTS = 'QUEUE_SCHEDULE_ASSIGNMENTS'
}

enum AssignmentSchedulingJobStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}

interface CommandExecutionModel {
  command: ScheduleCommand;
  arguments: Record<string, any>;
}

interface GetAvailabilitiesParamsModel {
  day?: Date;
  numberOfNextDays?: number;
  includeDefaultAvailability?: boolean;
}

interface AvailabilityModel {
  entityId: string;
  day: Date;
  minutes: number;
}

interface AssignmentSchedulingJobStatusModel {
  status: AssignmentSchedulingJobStatus;
}

export { AssignmentSchedulingJobStatus, ScheduleCommand };
export type {
  AssignmentSchedulingJobStatusModel,
  AvailabilityModel,
  CommandExecutionModel,
  GetAvailabilitiesParamsModel
};
